import { render } from "./ExpensePaymentForm.vue?vue&type=template&id=318f8264"
import script from "./ExpensePaymentForm.vue?vue&type=script&lang=js"
export * from "./ExpensePaymentForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__